<template>
  <div>
    <HeaderCreditor header="ใบ PU" :img_header="header_image" link_back="creditor/puinvoice"/>
    <PU_details/>
  </div>
</template>

<script>
import HeaderImage from '@/assets/document_2.png'
import HeaderCreditor from "@/components/admin/creditor/headercreditor/HeaderCreditor.vue";
import PU_details from "@/components/admin/creditor/puinvoice/PU_details.vue";
export default {
  name: "PUdetails",
  components: {
    PU_details,
    HeaderCreditor
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
